// Every project's service tier (USA-455): Standard runs itself, Service has a person driving it to a
// deliver-by date, Planned is consolidated through our warehouse. No tier on record reads as Standard.
export const SERVICE_TIERS = ['standard', 'service', 'planned'] as const
export type ServiceTier = (typeof SERVICE_TIERS)[number]

export const SERVICE_TIER_LABELS: Record<ServiceTier, string> = {
  standard: 'Standard',
  service: 'Service',
  planned: 'Planned',
}

export const SERVICE_TIER_FILTER_OPTIONS = ['all', ...SERVICE_TIERS] as const
export type ServiceTierFilterValue = (typeof SERVICE_TIER_FILTER_OPTIONS)[number]

/** The ``service_tier`` query value for a filter choice: nothing for "all". */
export function serviceTierParam(value: ServiceTierFilterValue): ServiceTier[] | undefined {
  return value === 'all' ? undefined : [value]
}

/** A tier read from the API, where a project without one is Standard. */
export function asServiceTier(value: string | null | undefined): ServiceTier {
  return value === 'service' || value === 'planned' ? value : 'standard'
}
